<template>
  <div class="product-section">
    <div class="mt-0">
      <advertisement-top-banner-text />
      <template v-if="$options.components['advertisement-loading']">
        <advertisement-loading v-if="isLoading" />
      </template>
      <div class="container mt-3">
        <b-row class="product-main my-3" v-if="productData">
          <b-col md="5" class="product-border product-images">
            <div
              v-if="productData['Discount'] || productData['Discount(%)']"
              class="show-variant"
            >
              <span
                v-if="productData['Discount']"
                class="variant-span text-icon price-normal"
              >
                {{ currency.symbol }}
                {{ productData["Discount"] }} off
              </span>
            </div>
            <b-row class="flex-column align-items-center">
              <b-col cols="12" class="text-center">
                <div class="align-items-center">
                  <b-img
                    id="product-img-1"
                    class="product-main-image my-3"
                    :src="imagesArr[activeBox]"
                    alt
                    height="320"
                    width="260"
                  />
                </div>
              </b-col>
              <b-col cols="12" class="d-flex justify-content-center">
                <div class="d-flex product-thumbnails">
                  <div
                    class="productdetail-imgshort mx-2"
                    v-for="(product, i) in imagesArr"
                    :key="i"
                    @mouseover="setActiveBox(i)"
                  >
                    <b-img
                      :src="product"
                      :class="[i === activeBox ? 'box-hovered' : 'box-common']"
                      center
                      height="100"
                      width="100"
                      id="product-img-1"
                      class="product-thumb-image"
                    />
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="7" class="product-info pr-0 pl-3">
            <v-breadcrumbs>
              <div>
                <span
                  class="product-address"
                  @click="$router.push(`${items.href}`)"
                  >{{ items.text }}</span
                >
                <v-icon>mdi-chevron-right</v-icon>
                <span
                  class="product-address"
                  @click="$router.push(`/category/${productData.Category}`)"
                  >{{ `${productData.Category}` }}</span
                >
                <v-icon>mdi-chevron-right</v-icon>
                <span class="text-no-href">{{ `${productData.Name}` }}</span>
              </div>
            </v-breadcrumbs>
            <h1
              class="product-name"
              v-if="productData.Name || productData.Quantity"
            >
              {{ productData.Name }}
            </h1>
            <div
              class="d-flex mt-3 justify-content-between justify-content-sm-between align-items-center product-price"
            >
              <div
                class="price-del-width"
                v-if="productData['Discount(%)'] || productData['Discount']"
              >
                <del class="text-icon price mb-0 mr-3"
                  >{{ currency.symbol }}
                  {{ Number(productData.Price).toFixed(2) }}
                </del>
                <h1 class="text-icon price mb-0 margin-left-8">
                  {{ currency.symbol }}
                  {{ Number(productData["Deal Price"]).toFixed(2) }} |
                  {{ productData.Quantity }}
                </h1>
              </div>

              <!-- <h1 v-if="!productData['Discount'] && !productData['Discount(%)']"
								class="mdi mdi-currency-usd text-icon price mb-0 product-price-mobile">
								{{ productData.Price }} USD
								<br />
								<span v-if="productData.Quantity"></span>
								{{ productData.Quantity }}
							</h1> -->
              <div
                v-if="!productData['Discount'] && !productData['Discount(%)']"
                class="price-container"
              >
                <div class="price-left">
                  <span class="price-amount">
                    {{ currency.symbol }}
                    {{ Number(productData.Price).toFixed(2) }}
                  </span>
                </div>
                <div v-if="productData.Quantity" class="quantity-container">
                  <span class="quantity-text">
                    {{ productData.Quantity }}
                  </span>
                </div>
              </div>
            </div>
            <div
              id="unit-button-box"
              class="mb-2"
              v-if="productVariants && productVariants.length"
            >
              <button
                :class="{
                  selectedUnit: activeVariant(productData, variant.attributes),
                }"
                @click="selectUnit(variant)"
                v-for="variant in productVariants"
                :key="variant._id"
              >
                {{ getVariantName(variant.attributes) }}
              </button>
            </div>

            <hr />
            <div
              v-if="
                productData.Availability &&
                productData.Availability.toLowerCase().trim() === 'out of stock'
              "
              class="text-center"
            >
              <p class="text-danger font-weight-bold">
                {{ $t("wishlistProduct.availability.outOfStock") }}
              </p>
            </div>
            <div class="d-flex align-items-center mb-2" v-else>
              <div class="d-flex align-items-center">
                <div class="add-button add-button-mobile" id="add-cart">
                  <template
                    v-if="$options.components['checkout-increment-decrement']"
                  >
                    <checkout-increment-decrement
                      :callCheckout="true"
                      :cartItem="productData"
                      :bigButtonClass="'product-add big-button btn-primary w-100'"
                      :showGoToCart="true"
                    />
                  </template>
                </div>
                <div class="product-icon-circle pointer heart">
                  <b-icon
                    size="xl"
                    icon="heart-fill"
                    @click="removeItem(productData)"
                    v-if="wishlistKey"
                  ></b-icon>
                  <b-icon
                    size="xl"
                    icon="heart"
                    @click="addToWishlist(productData)"
                    v-else
                  ></b-icon>
                </div>
              </div>
            </div>
            <hr />
            <div class="d-flex" v-if="productData.providerName">
              <dt class="mr-1">{{ $t("provider") }} :</dt>
              <!-- :to="{
									path: `/shopDetails/${productData.provider}/${productData.providerName}`,
								}" -->
              <dt>
                <router-link to="">{{ productData.providerName }}</router-link>
              </dt>
            </div>

            <div class="product-details">
              <dt>{{ $t("productDetails") }} :</dt>
              <dd v-if="productData.Name">
                {{ $t("productName") }} : {{ productData.Name }}
              </dd>
              <dd v-if="productData && productData.City && productData.State">
                {{ $t("city") }} : {{ productData.City }}
                {{ productData.State }}
              </dd>
              <dd v-if="productData && productData.Description">
                {{ productData.Description }}
              </dd>
            </div>
          </b-col>
        </b-row>
        <h5><strong>Customer Review</strong></h5>
        <b-card>
          <!-- Rating Summary -->
          <b-row class="align-items-center">
            <b-col md="3">
              <div class="text-left">
                <h6>
                  Overall Rating
                  <span class="text-muted">({{ ratingCount }})</span>
                </h6>
                <div class="text-warning h4">
                  <b-icon
                    v-for="n in Math.floor(ratingAverage)"
                    :key="'full-' + n"
                    icon="star-fill"
                    class="text-warning"
                  />
                  <b-icon
                    v-if="ratingAverage % 1 >= 0.5"
                    icon="star-half"
                    class="text-warning"
                  />
                  <b-icon
                    v-for="n in 5 - Math.ceil(ratingAverage)"
                    :key="'empty-' + n"
                    icon="star"
                    class="text-warning"
                  />
                </div>
              </div>
            </b-col>
            <b-col md="5">
              <div
                v-for="star in [5, 4, 3, 2, 1]"
                :key="star"
                class="d-flex align-items-center mb-1"
              >
                <span class="" style="width: 60px">
                  {{ star }}
                  <b-icon class="text-warning ml-2" icon="star-fill" />
                </span>
                <b-progress
                  :value="getRatingPercentage(star)"
                  :max="100"
                  height="12px"
                  class="flex-grow-1"
                  variant="success"
                ></b-progress>
                <!-- <span class="ml-2 text-muted" style="width: 50px">
                  {{ getRatingPercentage(star) }}%
                </span> -->
              </div>
            </b-col>
            <b-col md="4"></b-col>
          </b-row>

          <!-- Review Summary Section -->
          <h6 class="mt-4"><strong>Customer Review Summary</strong></h6>
          <div v-if="allRatings.length > 0">
            <div
              v-for="(review, index) in displayedReviews"
              :key="index"
              class="mb-4"
            >
              <b-card class="shadow-sm">
                <b-row>
                  <b-col md="1">
                    <b-avatar :src="review.avatar" size="48px"></b-avatar>
                  </b-col>
                  <b-col md="11">
                    <b-row>
                      <b-col md="6">
                        <div
                          class="d-flex justify-content-start align-items-center"
                        >
                          <h6 class="mb-1 mr-2">{{ review.name }}</h6>
                          <small class="text-muted">{{ review.date }}</small>
                        </div>
                        <div class="text-warning mb-2">
                          <b-icon
                            icon="star-fill"
                            v-for="n in review.rating"
                            :key="`f-${n}`"
                          />
                          <b-icon
                            icon="star"
                            v-for="n in 5 - review.rating"
                            :key="`e-${n}`"
                          />
                        </div>
                        <p class="text-muted mb-2">{{ review.comment }}</p>
                        <div class="badgeMain">
                          <b-badge
                            v-for="(tag, i) in review.tags"
                            :key="i"
                            variant="info"
                            class="mr-1"
                          >
                            {{ tag }}
                          </b-badge>
                        </div>
                      </b-col>
                      <b-col md="6">
                        <b-row>
                          <b-col
                            v-for="(media, i) in review.media"
                            :key="i"
                            cols="3"
                          >
                            <b-img
                              :src="media.url"
                              thumbnail
                              fluid
                              class="product-image"
                              @click="openImageModal(media.url)"
                            />
                          </b-col>
                        </b-row>
                        <b-modal
                          id="image-viewer-modal"
                          size="lg"
                          centered
                          hide-footer
                          v-model="showImageModal"
                        >
                          <div class="text-center imgPopup">
                            <b-img :src="selectedImageUrl" fluid></b-img>
                          </div>
                        </b-modal>
                      </b-col>
                    </b-row>

                    <!-- Seller Response -->
                    <b-row>
                      <b-col md="6"></b-col>
                      <b-col md="6">
                        <div
                          v-if="
                            review.sellerResponses &&
                            review.sellerResponses.length
                          "
                        >
                          <b-card
                            v-for="(res, idx) in review.sellerResponses"
                            :key="idx"
                            class="mb-2 sellerCard"
                            bg-variant="light"
                            border-variant="muted"
                            text-variant="dark"
                          >
                            <small>
                              <strong class="mr-1">{{ res.by }}(Seller)</strong>
                              {{ res.date }}
                            </small>
                            <p class="mb-0">{{ res.message }}</p>
                          </b-card>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </div>
          <div v-else class="text-center py-4 text-muted">
            No reviews available.
          </div>

          <!-- View All Button -->
          <div v-if="allRatings.length > 3" class="text-center">
            <b-button variant="primary" class="px-5" @click="toggleReviewView">
              {{ showAllReviews ? "Show Less" : "View All" }}
            </b-button>
          </div>
        </b-card>

        <b-row>
          <b-col lg="12" md="12" sm="12">
            <b-tabs content-class="" nav-class="justify-content-center">
              <b-tab :title="$t('description')">
                <div class="product-description">
                  <h5>{{ $t("productDescription") }}</h5>
                  <div class="description-content">
                    <p>
                      {{
                        productData && productData.Description
                          ? productData.Description
                          : ""
                      }}
                    </p>
                  </div>
                </div>
              </b-tab>
              <b-tab :title="$t('additionalInformation')">
                <div class="product-description">
                  <h5 class="section-title">
                    {{ $t("additionalInformation") }}
                  </h5>
                  <div class="info-grid">
                    <div
                      class="info-item"
                      v-if="productData && productData.Quantity"
                    >
                      <span class="info-label">{{ $t("quantity") }}:</span>
                      <span class="info-value">{{ productData.Quantity }}</span>
                    </div>

                    <div
                      class="info-item"
                      v-if="productData && productData.Availability"
                    >
                      <span class="info-label"> {{ $t("stockStatus") }}:</span>
                      <span class="info-value">{{
                        productData.Availability
                      }}</span>
                    </div>

                    <div
                      class="info-item"
                      v-if="productData && productData.Category"
                    >
                      <span class="info-label"
                        >{{ $t("category.category") }}:</span
                      >
                      <span class="info-value">{{ productData.Category }}</span>
                    </div>

                    <div
                      class="info-item tags-container"
                      v-if="
                        productData &&
                        productData.tags &&
                        productData.tags.length
                      "
                    >
                      <span class="info-label pb-2">{{ $t("tags") }} :</span>
                      <div class="tags-wrapper">
                        <span
                          v-for="tag in productData.tags"
                          :key="tag"
                          class="tag-badge"
                        >
                          {{ tag }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </div>

      <sections-slider
        v-if="relatedItems && relatedItems.length"
        :list="relatedItems"
        :subTitle="$t('relatedProducts')"
        :hasBackground="true"
        :showTitle="true"
        :hasButton="false"
        :withoutSlider="true"
        :maxItems="4"
        class="suggested-slider"
      >
        <template slot="default" slot-scope="{ listItem }">
          <div class="item-box">
            <items-item
              :itemNoBg="true"
              :product="listItem"
              :incrementDecrementKey="true"
              class="suggester-div card-hover"
            >
            </items-item>
          </div>
        </template>
      </sections-slider>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  data: function () {
    return {
      changeColor: false,
      items: {
        text: "Home",
        disabled: true,
        href: "/",
      },
      isLoading: false,
      topBanner: false,
      activeBox: 0,
      productId: "",
      productRatings: {
        ratings: [],
      },
      imagesArr: [],
      //selectedItemUnit: null,
      selectedProductVariantId: null,
      ratingStar: null,
      feedbackComment: "",
      baseProductId: null,
      showAllReviews: false,
      showImageModal: false,
      selectedImageUrl: "",
    };
  },

  computed: {
    ...mapState({
      marketList: (state) => state["home"].marketList,
      listData: (state) => state.wishlist.listData,
      userInfo: (state) => state.auth.userInfo,
      currency: (state) => state.home.currency,
      isLoggedin: (state) => state.auth.isLoggedin,
      productVariantData: (state) => state.product.productVariantData,
      productFeedbackList: (state) => state.product.productFeedbackList,
      currentPosition: (state) => state.location.currentPosition,
      reviewData: (state) => state.profile.reviewData,
    }),
    ...mapGetters({
      getProductData: "product/getProductData",
      getRelatedItems: "product/getRelatedItemsData",
      getProductFeedbackData: "product/getProductFeedbackData",
    }),
    allRatings() {
      const data = this.reviewData?.data || [];
      const ratings = [];
      let publishedData = data.filter(
        (item) => item.ratings[0].reviewStatus === "PUBLISH",
      );
      publishedData.forEach((item) => {
        (item.ratings || []).forEach((r) => {
          const comments =
            r.comments?.map((c) => ({
              by: c.commentedBy?.name || "Seller",
              date: new Date(c.commentedBy?.time).toLocaleDateString(),
              message: c.comment,
            })) || [];

          ratings.push({
            name: `${r.givenBy?.name?.first || "Anonymous"} ${r.givenBy?.name?.last || ""}`,
            avatar: "https://via.placeholder.com/48",
            date: new Date(item.createdAt).toLocaleDateString(), // ✅ now this works
            rating: r.stars || 0,
            comment: r.feedbackComment || "",
            media: r.media || [],
            tags: r.text || [],
            sellerResponses: comments,
            // status: r.reviewStatus || "Pending",
          });
        });
      });

      return ratings;
    },
    displayedReviews() {
      return this.showAllReviews
        ? this.allRatings
        : this.allRatings.slice(0, 3);
    },

    ratingAverage() {
      return this.reviewData?.data?.[0]?.ratingAverage || 0;
    },

    ratingCount() {
      return this.reviewData?.data?.reduce(
        (acc, item) => acc + (item.ratingCount || 0),
        0,
      );
    },

    wishlistKey() {
      const data = this.listData;
      const isAvailable = data.some((obj) => obj._id === this.productData._id);
      if (isAvailable) {
        return true;
      } else {
        return false;
      }
    },
    productData() {
      return this.getProductData(this.$route.params.data);
    },
    productVariants() {
      if (this.productData.variations) return this.productData.variations;
      else return [];
    },
    isVariationAvailable() {
      if (this.productData.variations) {
        return true;
      } else {
        return false;
      }
    },

    relatedItems() {
      return this.productData?.catalogId
        ? this.getRelatedItems(this.productData.catalogId)
        : [];
    },
    productFeedback() {
      return this.baseProductId
        ? this.getProductFeedbackData(this.baseProductId)
        : [];
    },
    ratingStarCount() {
      if (this.productFeedback) {
        return this.productFeedback.ratingAverage;
      } else {
        return 0;
      }
    },
  },
  methods: {
    ...mapActions({
      fetchWishlist: "wishlist/listWishList",
      fetchPartnerInfo: "shopDetails/fetchPartnerInfo",
      fetchRelatedItems: "product/fetchRelatedItemData",
    }),
    clear() {
      this.feedbackComment = "";
    },
    activeVariant(obj1, obj2) {
      for (const key in obj2) {
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }
      return true;
    },
    openImageModal(url) {
      this.selectedImageUrl = url;
      this.showImageModal = true;
    },
    async fetchRelatedItems() {
      //  if (!this.productData?.catalogId) return [];
      try {
        let payload = {
          city: this.currentPosition.data.City,
          location: {
            lat: this.currentPosition.lat,
            lon: this.currentPosition.lng,
          },
          distance: 10,
          catalogs: [this.productData?.catalogId],
        };
        await this.fetchRelatedItems(payload);
        return this.getRelatedItems;
      } catch (e) {
        return [];
      }
    },
    getVariantName(attr) {
      let str = "";
      Object.keys(attr).forEach((el, ind) => {
        let textVar = `${el}: ${attr[el]}`;
        if (ind !== Object.keys(attr).length - 1) {
          textVar = textVar + " |";
        }
        str = str + " " + textVar;
      });
      return str;
    },
    async selectUnit(variant) {
      try {
        await this.$store.dispatch("product/fetchProductVariantDetails", {
          variantId: variant._id,
          itemId: this.$route.params.data,
        });
        // this.productData._id = this.productVariantData._id;
        // if (this.productData['Deal Price']) {
        //   this.productData['Deal Price'] =
        //     this.productVariantData['Deal Price'];
        // }
        // if (this.productData['Discount(%)']) {
        //   this.productData['Discount(%)'] =
        //     this.productVariantData['Discount(%)'];
        // }
        // if (this.productData['Discount']) {
        //   this.productData['Discount'] = this.productVariantData['Discount'];
        // }
      } catch (error) {
        this.$swal({
          title: "Opps!!!!!",
          text: error.message,
          type: "warning",
        });
      }
    },

    async getProductDetails() {
      this.isLoading = true;
      try {
        await this.$store.dispatch(
          "product/fetchProductDetails",
          this.$route.params.data,
        );

        this.imagesArr = [];
        for (const i in this.productData.images) {
          if (typeof this.productData.images[i] == "string") {
            this.imagesArr.push(this.productData.images[i]);
          }
        }
        this.isLoading = false;
        let payload = {
          city: this.currentPosition.data.City,
          location: {
            lat: this.currentPosition.Lat,
            lon: this.currentPosition.Lng,
          },
          distance: 10,
          catalogs: [this.productData?.catalogId],
        };
        await this.$store.dispatch("product/fetchRelatedItemData", payload);
        await this.$store.dispatch(
          "product/fetchProductFeedback",
          this.productData._id,
        );
      } catch (e) {
        console.log(e);
      }
    },

    async submitProductReview() {
      let payload = {
        subjectId: this.baseProductId,
        ratings: {
          stars: this.ratingStar,
          feedbackComment: this.feedbackComment,
          givenBy: {
            name: {
              first: this.userInfo.name.first,
              last: this.userInfo.name.last,
            },
          },
        },
      };
      try {
        await this.$store.dispatch("product/updateProductReview", payload);
        this.$swal({
          title: this.$t("swal.title"),
          text: this.$t("swal.feedback"),
          type: "success",
        });
        this.$bvModal.hide("product-review");
        await this.$store.dispatch(
          "product/fetchProductFeedback",
          this.baseProductId,
        );
        this.ratingStar = null;
        this.feedbackComment = "";
      } catch (err) {
        this.$swal({
          title: "Opps !!!",
          text: this.$t("swal.feedbackAlready"),
          type: "warning",
        });
        this.$bvModal.hide("product-review");
      }
    },

    async addToWishlist(productData) {
      if (!this.isLoggedin) {
        this.$router.push("/login-with");
      } else {
        await this.$store.dispatch("wishlist/addToWishlist", productData);
        this.$swal({
          title: this.$t("wishlistProduct.successTitle"),
          text: this.$t("wishlistProduct.addedSuccess"),
          type: "success",
          timer: 1000,
        });
      }
    },
    async removeItem(productData) {
      await this.$store.dispatch("wishlist/removeToWishList", productData);
      this.$swal({
        group: "item",
        title: this.$t("wishlistProduct.successTitle"),
        text: this.$t("wishlistProduct.removedSuccess"),
        type: "success",
        timer: 1000,
      });
    },
    setActiveBox(i) {
      this.activeBox = i;
    },
    toggleReviewView() {
      this.showAllReviews = !this.showAllReviews;
    },
    getRatingPercentage(star) {
      const ratingCounts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      const data = this.reviewData?.data || [];

      data.forEach((reviewGroup) => {
        (reviewGroup.ratings || []).forEach((rating) => {
          const stars = rating.stars;
          if (stars >= 1 && stars <= 5) {
            ratingCounts[stars]++;
          }
        });
      });

      const total = Object.values(ratingCounts).reduce((a, b) => a + b, 0);
      if (!total) return 0;

      return Math.round((ratingCounts[star] / total) * 100);
    },
  },
  onClickButton() {
    this.showButton = true;
  },
  async mounted() {
    this.fetchWishlist();
    await this.getProductDetails();
    if (this.productData && this.productData._id) {
      this.$store.dispatch("profile/getReviewData", this.productData._id);
    } else {
      console.warn("productData or _id is undefined in mounted()");
    }
    this.fetchRelatedItems();
    this.baseProductId = this.productData._id;
    await this.$store.dispatch(
      "shopDetails/fetchPartnerInfo",
      this.productData.provider,
    );

    let selectedMarket = this.marketList?.filter(
      (el) => el.name == this.productData.Market,
    );
    let theme = selectedMarket[0].theme;
    this.$store.commit("theme/updateTheme", theme);
    let marketName = selectedMarket[0].name;
    this.$store.commit("theme/updateName", marketName);
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped>
.text-warning b-icon {
  margin-right: 2px;
}

.productdetail-imgshort {
  max-width: 120px;
  max-height: 120px;
  text-align: center;
}

.suggested-slider .item-box {
  margin: 0 12px;
  width: 266px;
  display: block;
}

.show-variant {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
}

.variant-span {
  position: absolute;
  background-color: #fd7e14;
  padding: 4px 10px 4px 35px;
  font-size: 20px;
  color: #fff;
  top: -595px;
  right: 0;
  z-index: 1;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 20% 50%);
  font-weight: 400;
}

.v-icon.v-icon {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
  padding: 0px !important;
}

.product-section {
  margin-top: 0px;
  padding: 0px 0 43px 0;
}

.product-add svg {
  font-size: 14px;
}

.product-images {
  padding: 15px;
}

.selectedUnit {
  color: var(--darkcolor) !important;
  border-color: var(--darkcolor) !important;
}

.item-quantity {
  border: 1px solid #b8b8b8;
  border-radius: 4px;
}

.add-button {
  flex: 1;
  width: 30%;
}

#add-cart {
  font-size: 14px;
  margin-right: 5px;
  margin-left: 5px;
  padding: 2px;
}

.heart {
  color: #2c742f;
  margin-left: 60px;
}

.product-icon-circle {
  background-color: #e9f8e9 !important;
}

.message {
  color: #41a9d6;
}

.product-main h1 {
  font-size: 2.5rem;
  /* Larger and more readable */
  font-weight: 700;
  padding-left: 6px;
  color: #222;
  font-family: inherit;
}

.product-location {
  font-size: 16px;
  color: #a4a4a4;
}

.product-main h2 {
  font-size: 2rem;
  font-weight: 600;
  color: #444;
  font-family: inherit;
}

.product-main dt {
  font-size: 1.25rem;
}

.product-details dd {
  font-size: 1.25rem;
  line-height: 1.5;
  color: #555;
  font-family: inherit;
}

.product-stars {
  margin-left: 15px;
  margin-right: 15px;
}

.product-star::before {
  width: 25px;
  font-size: 25px;
  color: var(--primarycolor);
}

.write-review {
  font-style: normal;
  font-weight: 600;
  font-size: 21px;
  line-height: 32px;
  text-decoration-line: underline;
  color: #ff3535;
  text-decoration: underline;
  cursor: pointer;
}

.star-count {
  border: 1px solid #000000;
  border-radius: 4px;
}

.product-price {
  font-size: 1.5rem;
  font-weight: 600;
  color: #000;
  display: flex;
  align-items: center;
  font-family: inherit;
}

.product-count {
  display: flex;
  justify-content: center;
  gap: 8px;
  align-items: center;
  cursor: pointer;
}

.product-count input {
  width: 40px;
  height: 30px;
  border: 1px solid #eaeaea;
  box-sizing: border-box;
  border-radius: 2px;
  text-align: center;
}

.card-hover:hover {
  border: 1px solid #272727;
  box-shadow: 0px 10px 20px 5px rgba(184, 178, 178, 0.5);
}

.product-count-icon {
  border-radius: 50%;
  border: 2px solid black;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#unit-button-box {
  display: flex;
  gap: 8px;
}

#unit-button-box button {
  color: #333;
  width: auto;
  height: auto;
  font-size: 1.25rem;
  font-weight: 500;
  background-color: transparent;
  border: #b8b8b8 1px solid;
  border-radius: 4px;
  padding: 2px 4px;
  font-family: inherit;
}

#unit-button-box button:hover {
  color: var(--primarycolor);
  border-color: var(--primarycolor);
}

.product-rate {
  margin-bottom: 12px;
}

.product-info .text-icon::before {
  width: 20px;
  position: relative;
  right: 3px;
}

.product-info button {
  background-color: var(--primarycolor);
  color: white;
  width: 140px;
  font-size: 16px;
  height: 45px;
  border-radius: 3px;
}

.product-address {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 20px;
  cursor: pointer;
  text-decoration: none;
}

.text-no-href {
  font-size: 1rem;
  font-weight: 600;
  color: #555;
  margin-bottom: 20px;
  text-decoration: none;
}

.product-address,
.text-no-href {
  font-size: 1.25rem;
  font-weight: 500;
  color: #666;
  font-family: inherit;
}

.product-main-image {
  object-fit: contain;
  height: 400px;
  /* Increased height */
  width: 320px;
}

.product-thumbnails {
  margin-top: 1rem;
}

.product-thumb-image {
  padding: 0.5rem;
  background-color: #fff;
  border: 1px solid #f2f2f2;
  border-radius: 0.25rem;
  object-fit: contain;
  height: 120px;
  /* Adjusted thumbnail height */
  width: 120px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.product-thumb-image:hover {
  transform: scale(1.1);
}

.product-border {
  border: 1px solid #f2f2f2;
  position: relative;
}

.underline-blue {
  color: #0275d8;
  text-decoration: underline;
}

.red-link {
  color: #ff3535;
  text-decoration: underline;
  font-size: 21px;
  margin-left: 72px;
}

.form-control {
  border: none;
}

.lds-roller {
  display: inline-block;
  text-align: center;
  width: 80px;
  height: 80px;
}

.color {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 21px;
  line-height: 32px;
  text-decoration-line: underline;
  color: #ff3535;
}
.badgeMain {
  align-items: center;
}
.badge {
  font-size: 12px;
  line-height: inherit;
  vertical-align: middle;
}

@media (max-width: 768px) {
  ::v-deep .v-breadcrumbs {
    padding: 18px 0px;
    padding-left: 6px;
  }

  .product-price-mobile {
    width: 80%;
    font-size: 1.5rem;
    font-family: inherit;
  }

  .add-button-mobile {
    width: 100%;
    font-family: inherit;
    font-size: 1.25rem;
  }

  .product-main-image {
    width: 100%;
  }

  .product-thumb-image {
    width: 100%;
  }

  .price-del-width {
    /* width: 80%; */
    display: block !important;
    padding-left: 6px;
  }

  .quantity-container {
    text-align: right;
    /* Move quantity to the right for small screens */
  }

  .productdetail-imgshort {
    max-width: 120px;
    max-height: 120px;
  }

  .product-info {
    padding: 1rem !important;
  }

  .product-price {
    align-items: flex-start;
  }

  .add-button {
    width: 100%;
    margin: 0;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .description-content {
    font-size: 0.9rem;
    line-height: 1.5;
  }

  ::v-deep .nav-tabs .nav-link {
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
  }
}
::v-deep .nav-tabs {
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 1.5rem;
}

::v-deep .nav-tabs::-webkit-scrollbar {
  display: none;
}

::v-deep .nav-tabs .nav-link {
  border: none;
  color: #666;
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  transition: all 0.3s ease;
  white-space: nowrap;
  font-size: 1.25rem;
}

::v-deep .nav-tabs .nav-link.active {
  color: var(--primarycolor);
  border-bottom: 2px solid var(--primarycolor);
  background-color: transparent;
  font-size: 1.25rem;
}
.badge-info {
  background-color: var(--primarycolor);
}

.sellerCard .card-body {
  padding: 10px;
}

.description-content {
  font-size: 1rem;
  line-height: 1.6;
  color: #4a4a4a;
}

.description-content p {
  margin-bottom: 1rem;
  white-space: pre-line;
  font-size: 20px;
}

.additional-info {
  padding: 1rem;
}

.description-title,
.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--primarycolor);
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #f0f0f0;
}

.product-description {
  padding: 0 20px;
  padding-bottom: 6px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.imgPopup img {
  width: 100%;
  object-fit: contain;
  height: 350px;
}

@media (max-width: 991px) {
  .product-main {
    margin: 1rem 0;
  }

  .product-images {
    margin-bottom: 2rem;
  }

  .product-main h1 {
    font-size: 22px;
  }

  .description-title,
  .section-title {
    font-size: 1.1rem;
    margin-bottom: 1.25rem;
  }
}

@media (max-width: 576px) {
  .product-border {
    border: none;
  }

  .description-title,
  .section-title {
    font-size: 0.95rem;
    margin-bottom: 0.75rem;
  }

  .description-content {
    font-size: 0.85rem;
  }

  .info-item {
    padding: 0.5rem;
  }

  .tags-wrapper {
    gap: 0.25rem;
  }
}

.tags-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.tag-badge {
  display: inline-block;
  padding: 0.35rem 0.75rem;
  background-color: var(--primarycolor);
  color: white;
  border-radius: 20px;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}

.tag-badge:hover {
  transform: scale(1.05);
}

.info-item {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.info-item:hover {
  background-color: #f0f0f0;
  transform: translateY(-2px);
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.5rem;
}

.tags-container {
  grid-column: 1 / -1;
}

.price-container {
  width: 100%;
  /* Ensures the container takes up full width of its parent */
  align-items: left;
}

.price-left {
  text-align: left;
  /* Align text to the left */
}

.price-amount {
  font-size: 22px;
  font-weight: 500;
}
.quantity-text {
  font-size: 22px;
  font-weight: 500;
}

.quantity-container {
  padding-left: 6px;
  text-align: left;
  /* Center the quantity on larger screens */
}
.price-del-width {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.product-image {
  width: 80px;
  cursor: pointer;
  height: 80px;
  object-fit: cover;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
</style>
